import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import moment from "moment";

//agregados por daniela
import { getOrgs } from "../../redux/organization/actions";
import { getTool } from "../../redux/climalaboral/tool/actions";

import messages from "../../redux/messages";
import SidebarConfig from "../../components/Clima/SidebarClimate";
//para el de cuestionario
import {
  getCAMPAÑA,
  getResponsables,
  deleteCampaña,
  sendMail,
} from "../../redux/climalaboral/campaña/action";
import CampaignDescription from "../../components/Clima/CampaignDescription";
import ModalCampaign from "../../components/Clima/ModalCampaign";
import CampaignSegmentAsignment from "../../components/Clima/CampaignSegmentAsignment";
import { useHistory } from "react-router-dom";
import SidebarDashboard from "../../components/SidebarDashboard";
import SegmentDescription from "../../components/Clima/SegmentDescription";
import ShowSendNotif from "../../components/Clima/campaña";

const Campaña = (props) => {
  // const userRoles = useSelector((store) => store.auth.userRoles);

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [viewItem, setViewItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalVisualization, setShowModalVisualization] = useState(false);
  const [showModalSegmentAsignment, setShowModalSegmentAsignment] =
    useState(false);
  const [showModalVisualizationSegmento, setShowModalVisualizationSegmento] =
    useState(false);
  // const [campo_filter, setCampo_filter] = useState('nombre_campaña');
  const [filter, setFilter] = useState("");
  // const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [codigo, setCodigo] = useState(null);

  const dispatch = useDispatch();

  const history = useHistory();

  const { campaña, campañaLength, loading } = useSelector(
    (store) => store.campaña
  );
  const pages = Math.ceil(campañaLength / limit);

  const userName = useSelector((store) => store.auth.username);
  const userRoles = useSelector((store) => store.auth.userRoles);


  const columns = [
    {
      Header: "Nombre de campaña",
      accessor: "nombre_campaña",
    },
    {
      Header: "Fecha inicio",
      accessor: "fecha_inicio",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_inicio
            ? moment(value.row.original.fecha_inicio).format("DD/MM/YYYY")
            : " - "}
        </div>
      ),
    },
    {
      Header: "Fecha fin",
      accessor: "fecha_fin",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_fin
            ? moment(value.row.original.fecha_fin).format("DD/MM/YYYY")
            : " - "}
        </div>
      ),
    },
    {
      Header: "Estado:",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${
            value.row.original.activa
              ? "bg-success text-light"
              : "bg-danger text-light"
          } p-2 rounded-pill text-center`}
          style={{
            minWidth: "90px",
          }}
        >
          {value.row.original.activa ? "Activa" : "Inactiva"}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_creacion
            ? moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")
            : " - "}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Descripción de la Campaña</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-info"
              onClick={() => onView(value.row.original, value.row.index)}
            >
              <i className="material-icons">visibility</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip {...props}>Agregar segmentos a la campaña</Tooltip>
            }
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-success"
              onClick={() => onAddSegment(value.row.original, value.row.index)}
            >
              <i className="material-icons">grid_view</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          {/* {userRoles.length > 0 && userRoles.includes("administrador") ? ( */}
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>eliminar</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
          {/* ) : null} */}
        </div>
      ),
    },
  ];

  const columnsResp = [
    {
      Header: "Nombre de campaña",
      accessor: "campania_list.nombre_campaña",
    },
    {
      Header: "Segmento",
      accessor: "segmento_list.nombre",
    },
    {
      Header: "Fecha inicio",
      accessor: "campania_list.fecha_inicio",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.campania_list &&
          value.row.original.campania_list.fecha_inicio
            ? moment(value.row.original.campania_list.fecha_inicio).format(
                "DD/MM/YYYY"
              )
            : " - "}
        </div>
      ),
    },
    {
      Header: "Fecha fin",
      accessor: "fecha_fin",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.campania_list &&
          value.row.original.campania_list.fecha_fin
            ? moment(
                value.row.original.campania_list &&
                  value.row.original.campania_list.fecha_fin
              ).format("DD/MM/YYYY")
            : " - "}
        </div>
      ),
    },
    {
      Header: "Estado:",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${
            value.row.original.campania_list &&
            value.row.original.campania_list.activa
              ? "bg-success text-light"
              : "bg-danger text-light"
          } p-2 rounded-pill text-center`}
          style={{
            minWidth: "90px",
          }}
        >
          {value.row.original.campania_list &&
          value.row.original.campania_list.activa
            ? "Activa"
            : "Inactiva"}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.campania_list &&
          value.row.original.campania_list.fecha_creacion
            ? moment(value.row.original.campania_list.fecha_creacion).format(
                "DD/MM/YYYY"
              )
            : " - "}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Descripción de la Campaña</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-info"
              onClick={() => onView(value.row.original, value.row.index)}
            >
              <i className="material-icons">campaign</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Descripción del segmento</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-info"
              onClick={() => onViewSegment(value.row.original, value.row.index)}
            >
              <i className="material-icons">groups</i>
            </Button>
          </OverlayTrigger>
          <ShowSendNotif
            item={value.row.original}
            index={value.row.index}
            userName={props.match.params.userName}
          />
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip {...props}>Enviar encuestas al correo</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              style={{ color: "#141E30" }}
              onClick={() => onMailSend(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">forward_to_inbox</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const getACampaña = (
    offs = offset,
    lim = limit,
    filt = filter,
    codi = codigo
  ) =>
    dispatch(
      getCAMPAÑA(
        {
          offset: offs,
          limit: lim,
          tipo_busqueda: "nombre",
          filter: filt,
        },
        codi
      )
    );

  const _dispatchMethods = (cod) => {
    setFilter("");
    getACampaña(offset, limit, filter, cod);
    dispatch(getResponsables({ rol_responsable: "responsable" }));
    dispatch(getTool({}));
    dispatch(getOrgs(2));
  };

  useEffect(() => {
    let filters = {
      rol_responsable: "responsable"
    }
    if(userRoles.includes("responsable")){
      filters.usuario_x_empresa = "si"
    }
    dispatch(getResponsables(filters));
  }, [userRoles]);

  useEffect(() => {
    if (props.match.params.userName) {
      setCodigo(props.match.params.userName);
      _dispatchMethods(props.match.params.userName);
    } else {
      setCodigo(null);
      _dispatchMethods(null);
    }
  }, [props.match.params.userName]);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    // setValidated(false);
  };

  const onView = (item, index) => {
    console.log(item);
    setViewItem(item);
    setShowModalVisualization(true);
  };

  const onViewSegment = (item, index) => {
    setViewItem(item);
    setShowModalVisualizationSegmento(true);
  };

  const onEdit = (item, index) => {
    var responsablesTemp = [];
    item.responsable_list.map((item) => {
      responsablesTemp = [...responsablesTemp, { value: item.id }];
    });
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    // setValidated(false);
  };

  const onAddSegment = (item, _index) => {
    setIndex(_index);
    setEditItem(item);
    setShowModalSegmentAsignment(true);
  };

  const onMailSend = (id) => {
    const req = {
      campania_segmento_id: id,
    };

    if (window.confirm("Seguro que quiere enviar esta campaña?")) {
      dispatch(sendMail(req));
    }
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACampaña(oOffset, limit, e.target.filter.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACampaña(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCampaña(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      {props.match.params.userName ? (
        <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      ) : (
        <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      )}
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              {!props.match.params.userName ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip {...props}>Ir campañas asignadas</Tooltip>}
                >
                  <Button
                    size="sm"
                    variant="light"
                    type="button"
                    className="rounded-circle mr-2"
                    onClick={() =>
                      history.push(`/campañas/responsable/${userName}`)
                    }
                  >
                    <i className="material-icons">turn_left</i>
                  </Button>
                </OverlayTrigger>
              ) : null}
              {props.match.params.userName
                ? "Campañas asignadas"
                : "Mantenimiento de campaña"}
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {props.match.params.userName ? null : (
                  <Col xs="auto">
                    <Form.Control
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      type="search"
                    ></Form.Control>
                  </Col>
                )}
                <Col xs="auto">
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip {...props}>Ver todo</Tooltip>}
                    >
                      <Button
                        onClick={() => seeAll()}
                        variant="light"
                        size="sm"
                        className="rounded-circle mr-2"
                      >
                        <i className="material-icons">list</i>
                      </Button>
                    </OverlayTrigger>
                    {props.match.params.userName ? null : (
                      <OverlayTrigger
                        placement="auto"
                        overlay={<Tooltip {...props}>Agregar</Tooltip>}
                      >
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-circle"
                          onClick={() => onAdd()}
                        >
                          <i className="material-icons">add</i>
                        </Button>
                      </OverlayTrigger>
                    )}
                    {props.match.params.userName ? (
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Ir al mantenimiento</Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant="light"
                          type="button"
                          className="rounded-circle ml-2"
                          onClick={() => {
                            _dispatchMethods(null);
                            history.push("/campaña");
                          }}
                        >
                          <i className="material-icons">shortcut</i>
                        </Button>
                      </OverlayTrigger>
                    ) : null}
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            campañaLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={
                        props.match.params.userName ? columnsResp : columns
                      }
                      data={campaña}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={campañaLength}
                  pages={pages}
                  pagFunc={getACampaña}
                />
              </>
            )
          )}
          {campañaLength === 0 && (
            <Alert variant="info" className="my-4">
              Aún no hay campañas, comienza agregando algunas
            </Alert>
          )}
        </Container>
      </div>
      {/* <Modal
        size="lg"
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setSubmitResp(false);
          setValidResp(true);
        }}
      >
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? "Editar campaña" : "Crear campaña"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="12">
                Nombre de campaña:
              </Form.Label>
              <Col sm="12" md="12">
                <Form.Control
                  name="nombre_campaña2"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.nombre_campaña : null}
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                  placeholder="Nombre de la campaña"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Row>
              <Form.Group as={Col} controlId="segmento2">
                <Row className="align-items-end">
                  <Col sm={segmentoLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Segmento</Form.Label>
                    <Form.Control
                      as="select"
                      id="segmento2"
                      name="segmento2"
                      className="rounded-pill"
                      required
                      defaultValue={edit ? editItem.segmento : null}
                      placeholder="Categoría"
                    >
                      {datasegmenT.map((segment) => (
                        <option value={segment.value}>{segment.label}</option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {segmentoLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="responsable2">
                <Row className="align-items-end">
                  <Col sm={responsableLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Responsable</Form.Label>
                    <MultiSelect
                      options={dataResp}
                      value={responsableT}
                      onChange={setResponsable}
                      isValid={validResp}
                      isDisabled={false}
                      isSubmit={submitResp}
                    />
                    {!validResp && (
                      <Col style={{ color: "red", fontSize: "12px" }}>
                        **Campo obligatorio
                      </Col>
                    )}
                  </Col>
                  {responsableLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="tipo_herramienta2">
                <Row className="align-items-end">
                  <Col sm={herramientasLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">
                      Tipo de Herramienta
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="tipo"
                      name="tipo"
                      className="rounded-pill"
                      required
                      defaultValue={edit ? editItem.tipo_herramienta : null}
                      placeholder="Categoría"
                    >
                      {herramientas.map((herramientas) => (
                        <option value={herramientas.id}>
                          {herramientas.nombre}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {herramientasLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="cuestionario2">
                <Row className="align-items-end">
                  <Col sm={cuestionarioLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Cuestionario</Form.Label>
                    <Form.Control
                      as="select"
                      id="cuestionario"
                      name="cuestionario"
                      className="rounded-pill"
                      required
                      defaultValue={edit ? editItem.cuestionario : null}
                      placeholder="Categoría"
                    >
                      {cuestionarioss
                        ? cuestionarioss
                            .sort((a, b) => {
                              if (a.nombre && b.nombre) {
                                if (
                                  a.nombre.toLowerCase() ===
                                  b.nombre.toLowerCase()
                                ) {
                                  return 0;
                                }
                                if (
                                  a.nombre.toLowerCase() <
                                  b.nombre.toLowerCase()
                                ) {
                                  return -1;
                                }
                              }
                              return 1;
                            })
                            .map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre ? item.nombre.toUpperCase() : ""}
                              </option>
                            ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Fecha no válida
                    </Form.Control.Feedback>
                  </Col>
                  {cuestionarioLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="fecha_inicio2">
                <Form.Label className="ml-2">Fecha de inicio</Form.Label>
                <Form.Control
                  name="fecha_inicio"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_inicio : null}
                  placeholder="Fecha de inicio"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Fecha no válida
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="fecha_fin2">
                <Form.Label className="ml-2">Fecha final</Form.Label>
                <Form.Control
                  name="fecha_fin"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_fin : null}
                  placeholder="Fecha final"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Fecha no válida
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="cuestionario2">
                <Row className="align-items-end">
                  <Col sm="12" md="6">
                    <Form.Label className="ml-2">Activo</Form.Label>
                    <Form.Control
                      as="select"
                      id="activa"
                      name="activa"
                      className="rounded-pill"
                      required
                      defaultValue={edit ? editItem.activa : null}
                      placeholder="Categoría"
                    >
                      {option.map((option) => (
                        <option value={option.value}>{option.label}</option>
                      ))}
                    </Form.Control>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoading}
              variant="primary"
              type="submit"
            >
              {saveLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}
      <ModalCampaign
        showModal={showModal}
        setShowModal={setShowModal}
        edit={edit}
        editItem={editItem}
        index={index}
        maintenance={true}
      />
      <CampaignDescription
        showModalVisualization={showModalVisualization}
        setShowModalVisualization={setShowModalVisualization}
        viewItem={
          props.match.params.userName ? viewItem.campania_list : viewItem
        }
        viewItemComplete={viewItem}
        userName={props.match.params.userName}
      />
      <SegmentDescription
        showModalVisualization={showModalVisualizationSegmento}
        setShowModalVisualization={setShowModalVisualizationSegmento}
        viewItem={viewItem.segmento_list}
      />
      <CampaignSegmentAsignment
        item={editItem}
        show={showModalSegmentAsignment}
        handleClose={() => setShowModalSegmentAsignment(false)}
        index={index}
        showModalVisualizationSegmento={showModalVisualizationSegmento}
        setShowModalVisualizationSegmento={setShowModalVisualizationSegmento}
      />
    </>
  );
};

export default Campaña;
